import gql from "graphql-tag";

export const GET_NOTE = gql`
    query Note($noteId: ID!){
        note(noteId: $noteId) {
            noteId
            userId
            parentType
            parentId
            shareCategoryType
            shareCategoryId
            note
            createdAt
            updatedAt
        }
    }
`;

export const GET_NOTES = gql`
    query Notes($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        notes(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            noteId
            userId
            parentType
            parentId
            shareCategoryType
            shareCategoryId
            note
            createdAt
            updatedAt
        }
    }
`;

export const GET_NOTES_OF_PARENT = gql`
    query NotesOfParent($parentType: String!, $parentId: ID!, $shareCategoryType: String!, $shareCategoryId: ID!, $searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        notesOfParent(parentType: $parentType, parentId: $parentId, shareCategoryType: $shareCategoryType, shareCategoryId: $shareCategoryId, searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            noteId
            userId
            parentType
            parentId
            shareCategoryType
            shareCategoryId
            note
            createdAt
            updatedAt
            integration {
                integrationName
            }
            team {
                teamName
            }
        }
    }
`;

export const CREATE_NOTE = gql`
    mutation CreateNote($newNote: newNote!) {
        createNote(
            newNote: $newNote
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_NOTE = gql`
    mutation UpdateNote($changedNote: changedNote!) {
        updateNote(
            changedNote: $changedNote
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_NOTE = gql`
    mutation DeleteNote($deleteNoteId: ID!) {
        deleteNote(
            deleteNoteId: $deleteNoteId
        ) {
            returnCode
            message
        }
    }
`;
